import React, { useRef } from 'react';
import Link from 'next/link';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import Cost from '@r1-frontend/ui-react/experimental/purchase/cost/Cost';
import { useResizeObserver } from '@r1-frontend/shared/hooks/useResizeObserver';

import ShopItems from '~/src/features/bundles/components/TariffLineOfferCard/containers/ShopItems';
import { TShopItemBody } from '~/src/features/bundles/types/TShopItemBody';

import * as ST from './styled';

interface IProps {
    img: string,
    imgWebp: string,
    title: string,
    selectButtonLink: string,
    onSelectTariff: () => void,
    priceFrom: number,
    shopItems: TShopItemBody[],
}

const TariffLineOfferCard = ({
    img,
    imgWebp,
    title,
    selectButtonLink,
    onSelectTariff,
    priceFrom,
    shopItems = [],
}: IProps): JSX.Element => {
    const wrapperRef = useRef(null);
    const { width } = useResizeObserver(wrapperRef);

    const isShopItems2ndCol = !!width && width > 485 && (shopItems.length >= 4 && shopItems.length <= 6);
    const isShopItems3rdCol = !!width && width > 700 && (shopItems.length >= 7 && shopItems.length <= 9);

    return (
        <ST.Wrapper ref={wrapperRef}>
            <ST.TopBlock>
                <ST.ImageContainer>
                    <WebpImage data-test='tariff-line-offer-card-preview' urlWebp={imgWebp}>
                        <ST.Image src={img} alt={'Изображение тарифной линейки'}/>
                    </WebpImage>
                </ST.ImageContainer>
                <ST.Title as='h2' data-test='tariff-line-offer-card-title' isHasTitle={!!title} dangerouslySetInnerHTML={{ __html: title ||  '' }}/>
            </ST.TopBlock>
            <ShopItems
                shopItems={shopItems}
                chunkSizeForCarousel={3}
                slidesToShow={isShopItems3rdCol ? 3 : 2}
                isOuterCardWrapperWide={isShopItems2ndCol || isShopItems3rdCol}
                data-test='tariff-line-offer-card-shopItems'
            />
            <ST.BottomBlock shopItemsCount={shopItems.length}>
                {selectButtonLink
                    ? (
                        <Link href={selectButtonLink} passHref data-test='tariff-line-offer-card-select-tariff-link'>
                            <Button onClick={onSelectTariff} bType={'action'}>Выбрать тариф от <Cost>{priceFrom}</Cost></Button>
                        </Link>
                    )
                    : <Button onClick={onSelectTariff} bType={'action'}>Подключить за  <Cost>{priceFrom}</Cost></Button>
                }
            </ST.BottomBlock>
        </ST.Wrapper>
    );
};

export default TariffLineOfferCard;
